import _ from '../vendors/_';

export default class EventEmitter {

  _listeners: { [key: string]: Function[] } = {};

  constructor() {
  }

  on(e: string, fn: Function): this {
    this._listeners[e] = this._listeners[e] || [];
    this._listeners[e].push(fn);
    return this;
  }

  off(e?: string, fn?: Function): this {
    _.forEach(this._listeners, (fns: Function[], _e: string) => {
      if (e && _e !== e) return;
      _.forEach(fns, (_fn: Function, i: number) => {
        if (fn && _fn !== fn) return;
        fns[i] = null;
      });
      fns = _.compact(fns);
      this._listeners[_e] = fns;
      if (fns.length === 0) delete this._listeners[_e];
    });
    return this;
  }

  emit(e: string, payload?: any): this {
    _.forEach(this._listeners[e], (_fn: Function, i: number) => {
      _fn && _fn(payload);
    });
    return this;
  }

}
